<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase v-bind="$attrs">
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.7803 4.96967C18.0732 5.26257 18.0732 5.73744 17.7803 6.03033L8.03025 15.7803C7.73736 16.0732 7.26249 16.0732 6.96959 15.7803L2.223 11.0337C1.9301 10.7408 1.9301 10.266 2.223 9.97307C2.51589 9.68018 2.99076 9.68018 3.28366 9.97307L7.49992 14.1893L16.7197 4.96967C17.0126 4.67678 17.4874 4.67678 17.7803 4.96967Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
